import React from 'react';
import Component from '@vfuk/core-simple-grid';
const SimpleGrid = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default SimpleGrid;
